import { FC } from 'react'
import cn from 'classnames'

interface TableCellProps {
  label: string
  isHeader?: boolean
}

export const TableCell: FC<TableCellProps> = ({ isHeader, label }) => (
  <p
    className={cn(
      'border-neutral-very-light flex min-h-16 items-center justify-center px-4 py-3 text-center text-base leading-6 whitespace-normal break-words first:border-r [overflow-wrap:anywhere] md:px-5',
      { 'text-primary-base font-semibold': isHeader }
    )}
  >
    {label}
  </p>
)
